import * as crypto from 'crypto-js';

export function getRandomHash() {
  return crypto.enc.Base64.stringify(
    crypto.SHA256(crypto.lib.WordArray.random(16))
  );
}
